import * as React from "react";
import { useGetAsset } from "security-app/hooks/useAssetsAPI";
const LoadAssetLabel = ({ assetId }) => {
  var _a;
  const { asset, loadingAsset } = useGetAsset(assetId);
  if (loadingAsset) {
    return /* @__PURE__ */ React.createElement("span", null, assetId);
  }
  if (!asset) {
    return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("i", null, "none"));
  }
  return /* @__PURE__ */ React.createElement("span", null, (_a = asset == null ? void 0 : asset.name) != null ? _a : assetId);
};
const AssociatedAssetLabel = ({ assetId }) => {
  if (assetId === null || assetId === "null") {
    return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("i", null, "none"));
  }
  return LoadAssetLabel({ assetId });
};
export default AssociatedAssetLabel;
